import type { ProjectData } from "./types";

export const RETAIL_PROJECTS: ProjectData[] = [
  {
    id: "maxmara-marassi",
    slug: "maxmara-boutique-marassi-galleria",
    title: "MaxMara Boutique - Marassi Galleria",
    seoTitle: "MaxMara Boutique Fit-Out | Marassi Galleria Bahrain",
    seoDescription:
      "Luxury MaxMara retail fit-out at Marassi Galleria Bahrain: Italian marble flooring, bespoke brass racks and airside mall compliance by Abacus.",
    category: "Commercial Stores & Retail",
    location: "Marassi Galleria Mall, Bahrain",
    client: "MaxMara Fashion Group",
    year: "2024",
    area: "320 sq. m.",
    description:
      "High-fashion luxury retail boutique featuring Italian marble flooring, bespoke custom brass racks, and airside-grade mall security compliance.",
    details:
      "Abacus delivered a complete turnkey fit-out for MaxMara following strict Italian brand guidelines. The project required precision custom joinery, integrated architectural recessed lighting, and overnight mall execution to preserve pristine mall operations.",
    challengeNarrative:
      "Executing complex Italian marble inlay flooring and custom brushed-brass fixture installations within tight night-shift delivery windows at Marassi Galleria Mall.",
    solutionNarrative:
      "Our in-house joinery and metal fabrication units pre-assembled modular wall units in Askar, enabling rapid dust-free on-site installation and zero schedule slippage.",
    scopeOfWork: [
      "Turnkey Fit-Out & Civil Contracting",
      "Italian Marble Flooring Installation",
      "Bespoke Brass Display Racks & Joinery",
      "Architectural Recessed Lighting",
      "Mall Security & Authority Compliance",
    ],
    tags: [
      "Turnkey Fit-Out",
      "In-House Joinery",
      "Custom Brass Fixtures",
      "ISO-Certified Inspection",
    ],
    image:
      "https://vibe.filesafe.space/1785525013889768799/attachments/b30bbccc-6cf2-4d9f-9df9-3bbb6a88d81f.jpg",
    imageAlt:
      "MaxMara boutique fit-out Marassi Galleria Bahrain storefront - luxury retail interior by Abacus",
    verifyNote:
      "Italian marble flooring, custom brass racks & airside-grade mall security compliance verified.",
    keyHighlights: [
      "100% adherence to Italian luxury brand specifications",
      "Pre-fabricated modular joinery from our Askar facility",
      "Handover completed 5 days ahead of official mall opening",
    ],
    additionalImages: [
      "https://vibe.filesafe.space/1785525013889768799/attachments/a7d82828-efbf-455f-a42a-40e7fb189262.jpg",
      "https://vibe.filesafe.space/1785525013889768799/attachments/a646ffd5-966f-4f88-ab9c-c11b84948680.jpg",
      "https://vibe.filesafe.space/1785525013889768799/attachments/779a727f-dff2-49cb-8048-6805b3b0c1f2.jpg",
      "https://vibe.filesafe.space/1785525013889768799/attachments/04374ad2-6072-4959-837d-412261b59686.jpg",
      "https://vibe.filesafe.space/1785525013889768799/attachments/a02e4a7a-caeb-462f-a8bd-8f085b304da6.jpg",
    ],
  },
  {
    id: "carter-white-marassi",
    slug: "carter-white-boutique-marassi-galleria",
    title: "Carter & White Boutique - Marassi Galleria",
    seoTitle: "Carter & White Boutique Fit-Out | Marassi Galleria Bahrain",
    seoDescription:
      "Bespoke luxury boutique fit-out for Carter & White at Marassi Galleria Bahrain: custom display joinery and tailored retail lighting by Abacus.",
    category: "Commercial Stores & Retail",
    location: "Marassi Galleria Mall, Bahrain",
    client: "Carter & White",
    year: "2024",
    area: "240 sq. m.",
    description:
      "Luxury in every detail: a refined boutique fit-out for the premium linen and lifestyle brand, blending modern and traditional design language with bespoke display joinery, premium finishes and precision retail lighting.",
    details:
      "Abacus delivered a full bespoke fit-out for Carter & White at Marassi Galleria Mall, executing intricate luxury joinery, custom display shelving, and mood lighting engineered to showcase fine textiles.",
    challengeNarrative:
      "Highlighting soft fabric textures through tailored color-temperature LED lighting while creating minimalist, seamless timber display fixtures.",
    solutionNarrative:
      "Utilized our Luminaire division for custom LED extrusion design combined with high-gloss lacquer wood joinery crafted in-house.",
    scopeOfWork: [
      "Turnkey Interior Fit-Out",
      "Custom High-Gloss Display Joinery",
      "Bespoke Abacus Luminaire LED Lighting",
      "Acoustic Ceiling Panels & Finishes",
      "Mall Authority Approval Coordination",
    ],
    tags: [
      "Turnkey Fit-Out",
      "Custom Display Joinery",
      "Retail Lighting",
      "Mall Compliance",
    ],
    image:
      "https://vibe.filesafe.space/1785525013889768799/attachments/1793aaf0-fc15-48ae-9594-477dbf1fddd6.jpg?v=2",
    imageAlt:
      "Carter & White luxury boutique fit-out Marassi Galleria Bahrain - bespoke retail interior by Abacus",
    verifyNote:
      "Scope details (joinery, finishes, lighting) verified - IG post confirms project delivery.",
    keyHighlights: [
      "Seamless integration of LED channels inside wooden joinery",
      "Flawless satin lacquer wood finishing produced in Askar spray booths",
      "Zero disruption to neighboring mall operations",
    ],
    additionalImages: [
      "https://vibe.filesafe.space/1785525013889768799/attachments/d513f4ab-c1cb-4635-a0c9-c5d355353be9.jpg",
      "https://vibe.filesafe.space/1785525013889768799/attachments/2f3c62da-c5db-4a7d-9dff-9780189e196e.jpg",
      "https://vibe.filesafe.space/1785525013889768799/attachments/b605c1b6-bdfd-4dcf-a616-58e329e925cd.jpg",
      "https://vibe.filesafe.space/1785525013889768799/attachments/0d9f818b-ac3f-4ea0-89c7-d07ce853d013.jpg",
      "https://vibe.filesafe.space/1785525013889768799/attachments/88d7ff54-a16b-4abc-9082-37714afef0aa.jpg",
    ],
  },
  {
    id: "malabar-gold",
    slug: "malabar-gold-diamonds-showroom",
    title: "Malabar Gold & Diamonds Showroom",
    seoTitle: "Malabar Gold & Diamonds Showroom | Manama Bahrain",
    seoDescription:
      "Luxury jewellery showroom fit-out for Malabar Gold & Diamonds in Manama: high-security display counters, recessed LED showcases and velvet trays by Abacus.",
    category: "Commercial Stores & Retail",
    location: "Manama, Bahrain",
    client: "Malabar Gold & Diamonds",
    year: "2023",
    area: "410 sq. m.",
    description:
      "Flagship luxury jewellery showroom with high-security display counters, recessed LED showcases, and velvet-lined custom trays.",
    details:
      "Crafted in our Askar joinery facility, the bespoke wood and brass counters provide maximum security and elegant presentation for gold and diamond collections.",
    challengeNarrative:
      "Integrating fortified vault-grade glass display security with ultra-high CRI lighting for diamond color brilliance.",
    solutionNarrative:
      "Engineered reinforced steel-backed counter frames layered with luxury walnut veneer and 98+ CRI custom lighting modules.",
    scopeOfWork: [
      "High-Security Display Joinery",
      "Reinforced Counter Steel Frameworks",
      "Ultra-High CRI Showcase Lighting",
      "Luxury Wall Cladding & Marble Features",
      "Integrated Alarm & MEP Cabling",
    ],
    tags: [
      "Security Display Joinery",
      "MEP & Smart Lighting",
      "Wall Cladding",
      "Turnkey Contracting",
    ],
    image:
      "https://vibe.filesafe.space/1785525013889768799/attachments/7c8088f6-4bbe-4544-8bcf-829e2183acf7.png",
    imageAlt:
      "Malabar Gold and Diamonds jewellery showroom fit-out Bahrain - illuminated display counters by Abacus",
    verifyNote:
      "Recessed LED showcases, security display counters & velvet trays verified.",
    keyHighlights: [
      "Fortified anti-theft joinery integrated into counter structures",
      "Custom velvet-lined display drawers with silent soft-close hardware",
      "Triple ISO quality control sign-off prior to opening",
    ],
    additionalImages: [
      "https://assets.cdn.filesafe.space/TkZSxIjkCDLzrMPXgP9Q/media/6a9095ca4fe741935419ba50.jpg",
      "https://assets.cdn.filesafe.space/TkZSxIjkCDLzrMPXgP9Q/media/6a9095ca722007d7fff70b90.jpg",
    ],
  },
  {
    id: "hugo-boss",
    slug: "hugo-boss-city-center",
    title: "Hugo Boss Store - City Center Bahrain",
    seoTitle: "Hugo Boss Store Fit-Out | City Center Bahrain",
    seoDescription:
      "Hugo Boss menswear boutique fit-out at City Center Bahrain: precision joinery, high-gloss lacquer and retail lighting to international brand standards by Abacus.",
    category: "Commercial Stores & Retail",
    location: "City Centre Bahrain, Manama",
    client: "Hugo Boss AG",
    year: "2023",
    area: "380 sq. m.",
    description:
      "Bespoke menswear boutique delivered in Bahrain's busiest mall - precision joinery and millwork, high-gloss lacquer woodwork and refined retail lighting, executed to Hugo Boss's international brand standards under strict mall regulations.",
    details:
      "Delivering a store for a global fashion house means meeting brand standards measured in millimetres. For Hugo Boss at City Center Bahrain, Abacus executed the complete interior fit-out - from detailed schematics and shop drawings through in-house furniture manufacturing and joinery, to electrical and mechanical works and final installation.\n\nEvery element was evaluated against the brand's international retail guidelines, then manufactured in our own Askar facility to guarantee finish quality and protect the opening date. The result: a refined menswear boutique that fuses Hugo Boss's global identity with flawless local execution - in one of Bahrain's highest-footfall retail destinations.\n\nThis project was awarded to Abacus by Jashanmal Group, who entrusted us with delivering the store to Hugo Boss's exacting international standards.",
    challengeNarrative:
      "Adhering to strict German brand guidelines while coordinating night-shift civil works in City Centre Bahrain.",
    solutionNarrative:
      "Our project engineering team managed 24/7 rotational shifts and prefabricated 85% of display fixtures off-site.",
    scopeOfWork: [
      "Full Fit-Out & Joinery Millwork",
      "High-Gloss Lacquer Wall Panelling",
      "Precision Track & Spot Lighting",
      "Digital Display Wall Integration",
      "Mall MEP & Civil Approvals",
    ],
    tags: [
      "Joinery & Millwork",
      "Retail Lighting",
      "Mall Compliance",
      "Fit-Out",
    ],
    image:
      "https://vibe.filesafe.space/1785525013889768799/attachments/90f42ad7-19bf-4199-9747-0877e401c069.png",
    imageAlt:
      "Hugo Boss store fit-out City Center Bahrain - precision joinery and retail lighting by Abacus",
    additionalImages: [
      "https://assets.cdn.filesafe.space/TkZSxIjkCDLzrMPXgP9Q/media/6a90968de20cab63728923fb.jpg",
      "https://assets.cdn.filesafe.space/TkZSxIjkCDLzrMPXgP9Q/media/6a90968d6572a4cf4c8954b2.jpg",
      "https://assets.cdn.filesafe.space/TkZSxIjkCDLzrMPXgP9Q/media/6a90968d60935b340b6ff478.jpg",
    ],
    verifyNote:
      "IG post confirms project + location; verified scope details (lacquer, lighting).",
    keyHighlights: [
      "Strict compliance with Hugo Boss global retail architecture",
      "High-gloss polyurethane lacquer spray finish executed in-house",
      "Complete handover on target date with zero defect punch list",
    ],
  },
  {
    id: "hackett-london",
    slug: "hackett-london-retail-outlet",
    title: "Hackett London Retail Outlet",
    seoTitle: "Hackett London Retail Fit-Out | City Centre Bahrain",
    seoDescription:
      "Hackett London retail outlet fit-out at City Centre Bahrain: heritage mahogany panelling, brass fittings and bespoke joinery crafted by Abacus.",
    category: "Commercial Stores & Retail",
    location: "City Centre Bahrain",
    client: "Hackett London",
    year: "2023",
    area: "290 sq. m.",
    description:
      "Classic British tailoring store featuring dark mahogany wall panelling, brass fittings, and plush carpet installation.",
    details:
      "Extensive custom woodworking fabricated in our Askar joinery unit to match London heritage aesthetic specifications.",
    challengeNarrative:
      "Matching antique mahogany grain and rich stain finishes specified by UK heritage designers.",
    solutionNarrative:
      "Master woodworkers at Abacus crafted custom stained mahogany cladding with hand-rubbed oil finishes.",
    scopeOfWork: [
      "Heritage Mahogany Wall Panelling",
      "Brass Architectural Fixtures",
      "Custom Fitting Room Millwork",
      "Luxury Carpet & Flooring",
      "Turnkey MEP & Lighting",
    ],
    tags: [
      "Custom Joinery",
      "Wall Paneling",
      "Flooring & Lighting",
      "Full Contracting",
    ],
    image:
      "https://vibe.filesafe.space/1785525013889768799/attachments/72126767-d769-4b71-8fbe-4d2425bc39fc.png",
    imageAlt:
      "Hackett London retail store fit-out Bahrain - marquee sign and bespoke display joinery by Abacus",
    additionalImages: [
      "https://vibe.filesafe.space/1785525013889768799/attachments/72ab0cd7-4f88-4fc8-ab96-17a02bbe8c29.jpg",
      "https://vibe.filesafe.space/1785525013889768799/attachments/c8472e56-a2e8-475d-8a96-f42e40c3e66f.jpg",
    ],
    keyHighlights: [
      "Bespoke British tailoring showroom aesthetic",
      "In-house carved timber moldings and antiqued metalwork",
      "Full turnkey handover within 28 days",
    ],
  },
  {
    id: "puma-concept",
    slug: "puma-concept-store-city-centre",
    title: "Puma Concept Store",
    seoTitle: "Puma Concept Store Fit-Out | City Centre Bahrain",
    seoDescription:
      "Puma concept store fit-out at City Centre Bahrain: modular steel displays, dynamic LED lighting and durable commercial flooring by Abacus.",
    category: "Commercial Stores & Retail",
    location: "City Centre Bahrain",
    client: "Puma Middle East",
    year: "2023",
    area: "350 sq. m.",
    description:
      "Dynamic sportswear store featuring modular steel footwear displays, energetic LED lighting, and industrial concrete finishes.",
    details:
      "High-traffic retail space built for brand experience and customer flow optimization.",
    challengeNarrative:
      "Creating industrial micro-cement floor textures alongside heavy-duty suspended steel display racks.",
    solutionNarrative:
      "Engineered ceiling anchorage systems for suspended displays and applied durable epoxy-concrete flooring.",
    scopeOfWork: [
      "Steel Display Structure Fabrication",
      "Epoxy Concrete Floor Coating",
      "Dynamic LED Feature Ring",
      "Acoustic Ceiling Grid",
      "Turnkey Store Delivery",
    ],
    tags: [
      "Steel Display Structures",
      "LED Feature Lighting",
      "Commercial Flooring",
      "Turnkey Fit-Out",
    ],
    image:
      "https://vibe.filesafe.space/1785525013889768799/attachments/66ed7074-04bb-4724-8c55-02f874d8d0ab.png",
    imageAlt:
      "Puma concept store interior City Centre Bahrain - retail fit-out with custom display joinery by Abacus",
    additionalImages: [
      "https://assets.cdn.filesafe.space/TkZSxIjkCDLzrMPXgP9Q/media/6a915f98722007d7ff06561e.jpg",
      "https://assets.cdn.filesafe.space/TkZSxIjkCDLzrMPXgP9Q/media/6a915f988ff22d3a75425690.png",
      "https://assets.cdn.filesafe.space/TkZSxIjkCDLzrMPXgP9Q/media/6a915f984fe7419354290918.png",
      "https://assets.cdn.filesafe.space/TkZSxIjkCDLzrMPXgP9Q/media/6a915f988ff22d3a75425694.jpg",
      "https://assets.cdn.filesafe.space/TkZSxIjkCDLzrMPXgP9Q/media/6a915f98ef6b5f0786e7dbb7.jpg",
    ],
    keyHighlights: [
      "High-durability commercial flooring designed for heavy foot traffic",
      "Custom metalwork fabricated in Abacus workshop",
      "Seamless integration of digital promotional screens",
    ],
  },
  {
    id: "bahrain-pharmacy",
    slug: "bahrain-pharmacy-city-centre",
    title: "Bahrain Pharmacy - City Centre Bahrain",
    seoTitle: "Bahrain Pharmacy Fit-Out | City Centre Bahrain",
    seoDescription:
      "Turnkey retail pharmacy fit-out at City Centre Bahrain: custom display joinery, curated lighting and MEP integration delivering a warm clinical interior by Abacus.",
    category: "Commercial Stores & Retail",
    location: "City Centre Bahrain, Manama",
    client: "Bahrain Pharmacy",
    year: "2024",
    area: "250 sq. m.",
    description:
      "Full retail pharmacy fit-out combining clinical precision with a warm, welcoming customer experience - delivered on schedule within one of Bahrain's busiest shopping destinations.",
    details:
      "Execution & Turnkey Delivery\nFull retail pharmacy fit-out combining clinical precision with a warm, welcoming customer experience - delivered on schedule within one of Bahrain's busiest shopping destinations.\n\nEngineering Challenge\nDesigning a pharmacy environment that balances strict regulatory compliance and clinical functionality with an inviting, modern retail aesthetic - all within the operational constraints of an active shopping centre.\n\nAbacus In-House Solution\nDeployed an integrated design-and-build team that merged contemporary retail layouts with traditional warmth, using custom joinery, curated lighting zones, and modular display systems to create a space that reflects the client's brand identity and enhances customer flow.",
    challengeNarrative:
      "Designing a pharmacy environment that balances strict regulatory compliance and clinical functionality with an inviting, modern retail aesthetic - all within the operational constraints of an active shopping centre.",
    solutionNarrative:
      "Deployed an integrated design-and-build team that merged contemporary retail layouts with traditional warmth, using custom joinery, curated lighting zones, and modular display systems to create a space that reflects the client's brand identity and enhances customer flow.",
    scopeOfWork: [
      "Retail Pharmacy Fit-Out (Turnkey)",
      "Custom Display & Storage Joinery",
      "Architectural Lighting Design & Installation",
      "Flooring, Ceilings & Wall Finishes",
      "Furniture Supply & Installation",
      "MEP & Electrical Integration",
    ],
    tags: [
      "Turnkey Fit-Out",
      "Custom Display Joinery",
      "Retail Pharmacy",
      "Lighting & MEP",
    ],
    image:
      "https://vibe.filesafe.space/1785525013889768799/attachments/d975e3d1-b32e-419c-9455-db1436d8a28b.png",
    imageAlt:
      "Bahrain Pharmacy fit-out at City Centre Bahrain - turnkey retail interior by Abacus",
    additionalImages: [
      "https://assets.cdn.filesafe.space/TkZSxIjkCDLzrMPXgP9Q/media/6a917acb854f9696b3b2f188.png",
      "https://assets.cdn.filesafe.space/TkZSxIjkCDLzrMPXgP9Q/media/6a917acb722007d7ff086bba.png",
      "https://assets.cdn.filesafe.space/TkZSxIjkCDLzrMPXgP9Q/media/6a917acb626105f9559bcdda.png",
    ],
    keyHighlights: [
      "01 Turnkey fit-out delivered within City Centre Bahrain's strict mall handover schedule",
      "02 Bespoke joinery and display cabinetry fabricated and installed by Abacus in-house team",
      "03 Seamless blend of modern clinical zones and warm retail design language",
    ],
  },
  {
    id: "damas-jewellery",
    slug: "damas-jewellery-city-centre-bahrain",
    title: "Damas Jewellery Showroom - City Centre Bahrain",
    seoTitle: "Damas Jewellery Showroom Fit-Out | City Centre Bahrain",
    seoDescription:
      "Luxury jewellery showroom fit-out for Damas at City Centre Bahrain: bespoke curved display counters, illuminated showcases and gold detailing by Abacus.",
    category: "Commercial Stores & Retail",
    location: "City Centre Bahrain, Manama",
    client: "Damas Jewellery",
    year: "2024",
    area: "300 sq. m.",
    description:
      "Luxury jewellery showroom interior design and fit-out for Damas Jewellery at City Centre Bahrain, combining bespoke curved display counters, illuminated glass showcases, warm timber finishes, champagne-gold detailing, and elegant customer consultation areas.",
    details:
      "Abacus Interior Decoration delivered a sophisticated retail environment for Damas Jewellery at City Centre Bahrain. The interior layout combines central display islands with perimeter showcases, creating a clear customer journey and maximising visibility across the showroom.\n\nThe curved forms of the display counters soften the retail environment and complement the arched architectural elements throughout the space. Integrated showcase lighting draws attention to the jewellery collections, while the use of glass, gold, wood, and textured neutral finishes creates a warm and luxurious atmosphere.",
    challengeNarrative:
      "Creating a distinctive jewellery showroom that attracts attention from the busy mall corridor while maintaining an intimate and comfortable atmosphere inside the store - balancing product display, customer circulation, visual merchandising, and private jewellery consultation within one cohesive space.",
    solutionNarrative:
      "A coordinated showroom design using bespoke curved display counters, illuminated jewellery showcases, gold-framed arches, decorative patterned screens, warm timber finishes, and soft seating areas. Central and wall-mounted displays keep collections visible from different viewpoints, while carefully positioned lighting enhances product presentation and the seating area supports one-to-one consultations.",
    scopeOfWork: [
      "Jewellery Showroom Interior Design",
      "Retail Interior Fit-Out",
      "Bespoke Curved Jewellery Display Counters",
      "Illuminated Wall-Mounted Showcases",
      "Freestanding Glass Display Units",
      "Gold-Finished Architectural Trims & Framing",
      "Feature Arched Entrance Portal",
      "Decorative Patterned Metal Screens",
      "Timber Wall Cladding & Feature Finishes",
      "Custom Ceiling Details & Feature Lighting",
      "Customer Seating & Consultation Areas",
    ],
    tags: [
      "Jewellery Showroom",
      "Bespoke Display Joinery",
      "Illuminated Showcases",
      "Turnkey Fit-Out",
    ],
    image:
      "https://assets.cdn.filesafe.space/TkZSxIjkCDLzrMPXgP9Q/media/6a91da5048ca8386eb01f298.jpg",
    imageAlt:
      "Damas Jewellery showroom facade and retail fit-out at City Centre Bahrain by Abacus",
    additionalImages: [
      "https://assets.cdn.filesafe.space/TkZSxIjkCDLzrMPXgP9Q/media/6a91da50722007d7ff11d743.jpg",
      "https://assets.cdn.filesafe.space/TkZSxIjkCDLzrMPXgP9Q/media/6a91da504fe7419354348e8e.jpg",
      "https://assets.cdn.filesafe.space/TkZSxIjkCDLzrMPXgP9Q/media/6a91da50058f231d6af2f727.jpg",
      "https://assets.cdn.filesafe.space/TkZSxIjkCDLzrMPXgP9Q/media/6a91da5048ca8386eb01f28f.jpg",
    ],
    keyHighlights: [
      "01 Bespoke curved jewellery display counters designed to improve product visibility and guide customer movement",
      "02 Illuminated glass showcases integrated into walls and freestanding units for elegant jewellery presentation",
      "03 Gold-framed arches, decorative screens and sculptural feature lighting creating a recognisable luxury retail identity",
    ],
  },
];
